import { Button, Card, Flex, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { toast } from 'react-toastify'
import { api } from '../functions/api'
import { useParams } from 'react-router-dom'
import Titre from '../components/Titre'
import { AlertOutlined, WarningOutlined } from '@ant-design/icons'

const GenerateBilanNotebookLM = () => {
  const { jeuneId, prenom } = useParams()

  const [cookies, setCookie, removeCookie] = useCookies(['id', 'token', 'cours_fav'])
  const [notesNoteBookLM, setNotesNoteBookLM] = useState('')
  const [openModalNoteBookLM, setOpenModalNoteBookLM] = useState(false)
  const [loadingFetchNoteBookLM, setLoadingFetchNoteBookLM] = useState(true)

  const prompts = [
    "Peux-tu me générer un résumé de la prise en charge du jeune à L'Interlude, tant scolairement que socialement, en identifiant les grandes catégories de sa prise en charge ? Ce résumé doit nous permettre de partager au pédopsychiatre et aux tuteurs du jeune son évolution chez nous.",
    "Peux-tu me générer un résumé de l'évolution du jeune pour chaque prof et chaque cours au sein de L'Interlude, tant scolairement que socialement ? Ce résumé doit nous permettre de partager au pédopsychiatre et aux tuteurs du jeune son évolution chez nous.",
    "Peux-tu me générer un résumé chronologique de l'évolution du jeune au sein de L'Interlude, tant scolairement que socialement ? Ce résumé doit nous permettre de partager au pédopsychiatre et aux tuteurs du jeune son évolution chez nous.",
  ]
  const generateBilanNoteBookLM = async (id) => {
    setOpenModalNoteBookLM(true)
    try {
      const response = await api('bilans/generate/' + jeuneId + '/notebooklm', {
        id: cookies['id'],
        token: cookies['token'],
      })
      setNotesNoteBookLM(response.data.texte)
    } catch (error) {
      console.error('Erreur lors de la récupération des jeunes:', error)
    } finally {
      setLoadingFetchNoteBookLM(false)
    }
  }
  const handleOk = () => {
    setOpenModalNoteBookLM(false)
  }
  const handleCancel = () => {
    setOpenModalNoteBookLM(false)
  }
  const copyToClipboard = (texte) => {
    navigator.clipboard
      .writeText(texte)
      .then(() => {
        toast.success('Copié dans le presse-papiers !')
      })
      .catch((err) => {
        toast.error('Erreur lors de la copie.')
        console.error('Erreur de copie :', err)
      })
  }
  useEffect(() => {
    generateBilanNoteBookLM()
  }, [])
  return loadingFetchNoteBookLM ? (
    <div className="Jeune fondPage">
      <Titre>Générer le bilan de {prenom} avec NotebookLM</Titre>
      <div className="page">
        <Flex align="center" justify="center" style={{ padding: 30 }}>
          <Spin />
        </Flex>
      </div>
    </div>
  ) : (
    <div className="Jeune fondPage">
      <Titre>Générer le bilan de {prenom} avec NotebookLM</Titre>
      <div className="page">
        <Flex vertical gap={20} style={{ padding: 30 }}>
          <h3>
            1. Se rendre sur NotebookLM et <u>CREER</u> un nouveau résumé
          </h3>
          <h5 style={{ color: '#E92209' }}>
            <WarningOutlined /> Tu dois être connecté avec ton compte @asihs.org
          </h5>
          <a href="https://notebooklm.google.com/" target="_blank" rel="noreferrer">
            <Button>Ouvrir NotebookLM</Button>
          </a>
          <h3>
            2. Coller les données <u>DANS LES SOURCES</u> de NotebookLM
          </h3>
          <div>
            <Button
              onClick={() => {
                copyToClipboard(notesNoteBookLM)
              }}
            >
              Copier les données dans le presse-papiers
            </Button>
          </div>
          <h3>3. Fournir le prompt à NotebookLM</h3>
          <Flex gap={20}>
            {prompts.map((prompt, key) => (
              <Card
                hoverable
                key={key}
                onClick={() => {
                  copyToClipboard(prompt)
                }}
              >
                <p>{prompt}</p>
              </Card>
            ))}
          </Flex>
          <h3>4. Validé le prompt et récupérer le bilan ainsi généré</h3>
        </Flex>
      </div>
    </div>
  )
}

export default GenerateBilanNotebookLM
